import { useEffect } from "react";
import { sseModule } from "../../store";
import { useAppDispatch } from "../../hooks";
import { useControlContext } from "../control";
import { requestModule } from "../auth";
import { chatActions } from "../chat";

const { getChatInfo } = chatActions;

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const { api, sse } = useControlContext();
  const { authApi, getChatInfoApi } = api;

  const sseLink = `${window.location.origin}/${sse.link}`;

  useEffect(() => {
    (async () => {
      requestModule.setAuthCallback(authApi);
      sseModule.setAuth(authApi, sseLink);
      dispatch(getChatInfo(getChatInfoApi));
    })();
  }, []);
};
